export const employeeCardsTableColumns = [
  {
    prop: 'holder.first_name',
    orderingParam: 'first_name',
    name: 'First name',
    flexGrow: 1,
    minWidth: 150,
  },
  {
    prop: 'holder.last_name',
    orderingParam: 'last_name',
    name: 'Last name',
    flexGrow: 1,
    minWidth: 150,
  },
  { prop: 'expiry_date', name: 'Expiry date', flexGrow: 1, minWidth: 150 },
  { prop: 'status', name: 'Card status', flexGrow: 1, minWidth: 100 },
  {
    prop: 'balance',
    name: 'Balance',
    flexGrow: 1,
    minWidth: 150,
    cellClass: 'text-end',
    headerClass: 'text-end',
  },
  {
    prop: 'actions',
    name: '',
    sortable: false,
    resizeable: false,
    canAutoResize: false,
    width: 56,
  },
];

export const subscriptionCardsTableColumns = [
  { prop: 'name', name: 'Card name', flexGrow: 2, minWidth: 250 },
  {
    prop: 'holder.first_name',
    orderingParam: 'first_name',
    name: 'First name',
    flexGrow: 1,
    minWidth: 150,
  },
  {
    prop: 'holder.last_name',
    orderingParam: 'last_name',
    name: 'Last name',
    flexGrow: 1,
    minWidth: 150,
  },
  { prop: 'expiry_date', name: 'Expiry date', flexGrow: 1, minWidth: 120 },
  { prop: 'status', flexGrow: 1, width: 100, canAutoResize: false },
  {
    prop: 'balance',
    name: 'Balance',
    flexGrow: 1,
    minWidth: 150,
    cellClass: 'text-end',
    headerClass: 'text-end',
  },
  {
    prop: 'actions',
    name: '',
    sortable: false,
    resizeable: false,
    canAutoResize: false,
    width: 100,
  },
];
